// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Na5xn","button":"style_button__5w9H-"};